import React from "react";
import { DATA_SOURCE } from "../../../../types/enum";
import "./DataSourceToggle.scss";

interface DataSourceToggleProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const DataSourceToggle: React.FC<DataSourceToggleProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const isMobbin = value === DATA_SOURCE.MOBBIN;

  // const handleToggle = () => {
  //   if (disabled) return;
  //   onChange(isMobbin ? DATA_SOURCE.CUSTOM : DATA_SOURCE.MOBBIN);
  // };

  return (
    <div className="data-source-toggle">
      <label className="toggle-label">데이터 소스</label>
      <div className="toggle-container">
        <button
          type="button"
          className={`toggle-option ${isMobbin ? "active" : ""}`}
          onClick={() => !disabled && onChange(DATA_SOURCE.MOBBIN)}
          disabled={disabled}
        >
          Mobbin
        </button>
        <button
          type="button"
          className={`toggle-option ${!isMobbin ? "active" : ""}`}
          onClick={() => !disabled && onChange(DATA_SOURCE.CUSTOM)}
          disabled={disabled}
        >
          none
        </button>
      </div>
    </div>
  );
};
